import React from 'react'
import {features} from 'helpers/constants'
import {urls} from 'helpers/url'
import {quoteSelectorUpdateFilters} from 'actions/quoting'
import {QuoteStatus} from 'helpers/quotes'
import iconNames from 'theme/icons'
import {t} from "helpers/language"

export const skill = {
  key: 'ADD_DELIVERY_NOTE',
  group: 'deliveries',
  label: t('Deliver your job'),
  desc: t('Schedule or mark your job as delivered, provide a tracking link to your customer and print a delivery note'),
  feature: features.DELIVERIES_LICENCE,
  steps: [
    {
      target: '.viewQuotesContainer',
      location: urls.quoting.searchQuotes,
      skip: () => !!window.location.href.match(/.+\/quoting\/quotes\/[0-9]+/gi) || !!window.location.href.match(/.+\/contacts\/manage\/.+\/quote\/[0-9]+/gi),
      action: () => quoteSelectorUpdateFilters({ statusTypes: [QuoteStatus.confirmed] }),
      content: (
        <div>
          You can deliver jobs which have first been confirmed. <i>Click on a confirmed job from the list</i>.<br/>
          <br/>
          If you don{'\''}t have a confirmed job, create one first then come back to this skill by hitting <i>F1</i>.
        </div>
      ),
      actions: [
        {
          label: 'Confirm a Job',
          flat: true,
          primary: false,
          type: 'skill',
          skill: 'RAISE_QUOTE',
        },
      ],
    },
    {
      target: '.tabs-deliveries',
      content: <div>First let{'\''}s go to the <i>Deliveries</i> tab</div>,
    },
    {
      target: '.quote-deliveries-view-deliverButton',
      content: <div>To deliver our job, we must raise a Delivery Note. To do this click <i>Add Delivery Note</i>.</div>,
    },
    {
      // Inline step in the delivery note dialog
      dummy: true,
    },
    {
      title: "Delivery Note Added",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: (
          <div>
            {"Well done, you've created a delivery note"}<br/>
            <br/>
            {"Continue the tour now to learn how to raise invoices"}
          </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Learn About Invoicing",
          primary: true,
          type: "skill",
          skill: "ADD_INVOICE",
        },
      ],
    },
  ],
}

export default skill
